import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { CashbookDto } from './cashbook-dto';


export class AllCashbookDetailsReponseModels extends GlobalResponseObject {
    data?: CashbookDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: CashbookDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

